export const DEFAULT_CELL_WIDTH = 150
export const LARGE_CELL_WIDTH = 180
export const XLARGE_CELL_WIDTH = 270
export const XXLARGE_CELL_WIDTH = 320
export const GROUPED_CELL_WIDTH = 230
